// JCCC Hospitality Management demo data
// Course numbers/titles from the JCCC Culinary & Hospitality Programs booklet (Fall 2025)
// Competencies are ACFEF-aligned demonstration mappings.

function mulberry32(a) {
  return function () {
    a |= 0; a = (a + 0x6D2B79F5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
const rand = mulberry32(20260716);
const pick = (arr) => arr[Math.floor(rand() * arr.length)];
const sample = (arr, n) => {
  const copy = [...arr]; const out = [];
  for (let i = 0; i < n && copy.length; i++) out.push(copy.splice(Math.floor(rand() * copy.length), 1)[0]);
  return out;
};

export const JCCC_COURSES = [
  { course: 'HMGT 123', title: 'Professional Cooking I', program: 'Chef Apprenticeship', credits: 3, lab: true,
    competencies: ['Knife skills and classical vegetable cuts','Stock, soup and mother sauce production','Dry- and moist-heat cooking methods','Sanitation and safe food handling in production','Standardized recipe conversion and mise en place'] },
  { course: 'HMGT 230', title: 'Professional Cooking II', program: 'Chef Apprenticeship', credits: 3, lab: true,
    competencies: ['Protein fabrication and advanced cookery','Pan sauces and sauce refinement','A-la-minute line service and timing','Plate composition and presentation standards'] },
  { course: 'HMGT 223', title: 'Fundamentals of Baking', program: 'Chef Apprenticeship', credits: 3, lab: true,
    competencies: ["Baking science and baker's percentage",'Yeast-raised dough production','Quick breads, cookies and basic pastry','Scaling accuracy and production scheduling'] },
  { course: 'HMGT 226', title: 'Garde Manger', program: 'Chef Apprenticeship', credits: 3, lab: true,
    competencies: ['Cold-food preparation and presentation','Charcuterie: cures, forcemeats and pates','Salads, dressings and emulsified sauces','Buffet design and cold-holding food safety'] },
  { course: 'HMGT 220', title: 'American Regional Cuisine', program: 'Chef Apprenticeship', credits: 3, lab: true,
    competencies: ['Regional American cuisines and foodways','Menu research and development','Batch production and sensory evaluation'] },
  { course: 'HMGT 231', title: 'Advanced Food Preparation', program: 'Chef Apprenticeship', credits: 4, lab: true,
    competencies: ['Multi-course menu planning and execution','Advanced and modernist technique application','Line leadership and station delegation','Food cost control in live production'] },
  { course: 'HMGT 271', title: 'Seminar: Purchasing', program: 'Food & Beverage Management', credits: 3, lab: false,
    competencies: ['Vendor selection and bid comparison','Purchase specifications and order guides','Receiving, storage and inventory control'] },
  { course: 'HMPB 155', title: 'Pastry Shop Production I', program: 'Pastry/Baking Certificate', credits: 4, lab: true,
    competencies: ['Retail pastry production at volume','Viennoiserie and laminated doughs','Retail display, packaging and guest service','Sanitation in bakery operations'] },
  { course: 'HMPB 233', title: 'Patisserie', program: 'Pastry/Baking Certificate', credits: 4, lab: true,
    competencies: ['Petits fours and entremets','Plated dessert design','Chocolate and sugar work fundamentals'] },
];

const INSTRUCTOR_BY_COURSE = {
  'HMGT 123': 'Gray', 'HMGT 230': 'Tatum', 'HMGT 223': 'Staff', 'HMGT 226': 'Gray',
  'HMGT 220': 'Tatum', 'HMGT 231': 'Staff', 'HMGT 271': 'Gray', 'HMPB 155': 'Gray', 'HMPB 233': 'Tatum',
};

const PANTRY = {
  SAVORY: [
    ['Chicken, Airline Breast','lb',4.15,'PROTEIN'],['Pork Tenderloin','lb',3.85,'PROTEIN'],
    ['Salmon, Atlantic Fillet','lb',9.4,'PROTEIN'],['Beef, Top Sirloin','lb',6.95,'PROTEIN'],
    ['Onions, Yellow Jumbo','lb',0.62,'PRODUCE'],['Carrots, Jumbo','lb',0.58,'PRODUCE'],
    ['Celery','ea',2.1,'PRODUCE'],['Garlic, Peeled','lb',3.95,'PRODUCE'],
    ['Potatoes, Russet 90ct','ea',0.55,'PRODUCE'],['Tomatoes, 6x6','lb',1.35,'PRODUCE'],
    ['Stock, Chicken','qt',2.25,'DRY GOODS'],['Oil, Canola','gal',8.9,'DRY GOODS'],
    ['Rice, Long Grain','lb',0.68,'DRY GOODS'],['Butter, Unsalted AA','lb',2.81,'DAIRY'],
    ['Cream, Heavy Whipping 36%','qt',4.02,'DAIRY'],['Lemons, 165ct','ea',0.42,'PRODUCE'],
  ],
  BAKING: [
    ['Flour, Bread','lb',0.48,'DRY GOODS'],['Flour, All Purpose','lb',0.42,'DRY GOODS'],
    ['Flour, Pastry','lb',0.52,'DRY GOODS'],['Sugar, Granulated','lb',0.55,'DRY GOODS'],
    ['Butter, Unsalted AA','lb',2.81,'DAIRY'],['Eggs, Large Grade AA','dz',2.33,'DAIRY'],
    ['Milk, Whole Homogenized','gal',3.27,'DAIRY'],['Yeast, Instant','lb',4.6,'BAKING'],
    ['Chocolate, Dark 64%','lb',6.85,'BAKING'],['Vanilla Extract','oz',1.15,'BAKING'],
    ['Cream, Heavy Whipping 36%','qt',4.02,'DAIRY'],['Almond Flour','lb',7.25,'BAKING'],
    ['Sugar, Powdered 10X','lb',0.72,'DRY GOODS'],['Cream Cheese, Loaf','lb',3.1,'DAIRY'],
  ],
  GARDE: [
    ['Pork Butt, Boneless','lb',2.65,'PROTEIN'],['Duck Breast','lb',8.75,'PROTEIN'],
    ['Greens, Spring Mix','lb',4.4,'PRODUCE'],['Cucumbers, Select','ea',0.65,'PRODUCE'],
    ['Oil, Extra Virgin Olive','l',9.85,'DRY GOODS'],['Vinegar, Champagne','l',6.4,'DRY GOODS'],
    ['Mustard, Dijon','lb',2.35,'DRY GOODS'],['Salt, Curing #1','lb',3.1,'DRY GOODS'],
    ['Casings, Hog','ea',22.0,'PROTEIN'],['Gelatin, Sheet Silver','ea',0.18,'BAKING'],
    ['Cheese, Chevre','lb',6.2,'DAIRY'],['Herbs, Assorted Fresh','ea',1.9,'PRODUCE'],
  ],
};
const POOL_BY_COURSE = {
  'HMGT 123': 'SAVORY', 'HMGT 230': 'SAVORY', 'HMGT 220': 'SAVORY', 'HMGT 231': 'SAVORY',
  'HMGT 223': 'BAKING', 'HMPB 155': 'BAKING', 'HMPB 233': 'BAKING', 'HMGT 226': 'GARDE',
};

const TOPICS_BY_COURSE = {
  'HMGT 123': ['Stocks & Mother Sauces','Knife Skills Assessment','Moist-Heat Methods','Dry-Heat Methods','Soups & Consommes'],
  'HMGT 230': ['Poultry Fabrication','Pan Sauces','Seafood Cookery','Line Service Practical','Plating Standards'],
  'HMGT 223': ['Yeast Dough Production',"Baker's Percentage Lab",'Quick Breads','Cookies & Bars','Pies & Tarts'],
  'HMGT 226': ['Emulsified Sauces','Cures & Brines','Forcemeats & Pates','Buffet Platters','Composed Salads'],
  'HMGT 220': ['Southwest & New Mexico','Lowcountry & Gulf','Heartland & BBQ','Pacific Northwest','New England'],
  'HMGT 231': ['Menu Development Lab','Sous Vide Applications','Multi-Course Service','Cost Control Practical'],
  'HMPB 155': ['Laminated Doughs','Viennoiserie Production','Retail Case Production','Holiday Production'],
  'HMPB 233': ['Entremets','Petits Fours','Plated Desserts','Chocolate Work'],
};

function itemsFor(courseNo, n) {
  const pool = PANTRY[POOL_BY_COURSE[courseNo] || 'SAVORY'];
  return sample(pool, Math.min(n, pool.length)).map(([name, unit, cost, category]) => {
    const quantity = pick([1, 2, 2, 3, 4, 5, 6, 8, 10, 12]);
    return { name, quantity, unit, category, extended: Math.round(quantity * cost * 100) / 100 };
  });
}

function makeReq(courseNo, class_date, weekNo, topicIdx, status) {
  const c = JCCC_COURSES.find((x) => x.course === courseNo);
  const topics = TOPICS_BY_COURSE[courseNo];
  const items = itemsFor(courseNo, 7 + Math.floor(rand() * 7));
  const actual = items.reduce((s, i) => s + i.extended, 0);
  return {
    id: `demo-${courseNo.replace(/\s/g, '')}-${class_date}`,
    course: courseNo, instructor: INSTRUCTOR_BY_COURSE[courseNo], program: c.program,
    class_date, week: `Week ${weekNo}: ${topics[topicIdx % topics.length]}`,
    status, budget: Math.round(actual * (1.05 + rand() * 0.18) * 100) / 100,
    items, split: false, competencies: sample(c.competencies, Math.min(3, c.competencies.length)),
  };
}

const LAB_COURSES = JCCC_COURSES.filter((c) => c.lab).map((c) => c.course);

const requisitions = [];
const springWeeks = [
  ['2026-01-14','2026-01-15'],['2026-01-21','2026-01-22'],['2026-01-28','2026-01-29'],
  ['2026-02-04','2026-02-05'],['2026-02-11','2026-02-12'],['2026-02-18','2026-02-19'],
  ['2026-02-25','2026-02-26'],['2026-03-04','2026-03-05'],
];
springWeeks.forEach((dates, wk) => {
  dates.forEach((d, j) => {
    const courseNo = LAB_COURSES[(wk + j * 3) % LAB_COURSES.length];
    requisitions.push(makeReq(courseNo, d, wk + 1, wk + j, 'ordered'));
  });
});
const summer = [
  ['2026-07-15',6],['2026-07-16',6],['2026-07-17',6],
  ['2026-07-21',7],['2026-07-22',7],['2026-07-23',7],['2026-07-24',7],
  ['2026-07-28',8],['2026-07-29',8],
];
summer.forEach(([d, wk], k) => {
  const courseNo = LAB_COURSES[k % LAB_COURSES.length];
  requisitions.push(makeReq(courseNo, d, wk, k, k < 5 ? 'approved' : 'submitted'));
});

const orders = [
  ['Sysco','2026-07-10','sent'],['US Foods','2026-07-10','sent'],
  ['Liberty Fruit Co.','2026-07-11','sent'],['Sysco','2026-07-13','pending'],
  ["McGonigle's Market",'2026-07-13','pending'],
].map(([vendor, d, status], i) => {
  const items = itemsFor(pick(LAB_COURSES), 9 + Math.floor(rand() * 7));
  return {
    id: `demo-order-${i}`, vendor, status, created_at: `${d}T14:20:00Z`, order_date: d,
    items, total: Math.round(items.reduce((s, x) => s + x.extended, 0) * 100) / 100,
    week: 'Week 6', notes: '',
  };
});

export const JCCC_DEMO = { requisitions, orders };
